import { useCallback, useMemo } from 'react';

import { analyticsApi } from 'apis/analytics';
import { useAppSelector } from 'utils/redux/useAppSelector';

import { InstrumentComparateSide } from '../instrumentComparison.types';

/** A hook that selects the instrument query state for each comparate. */
export const useComparisonInstrumentsQueryState = () => {
  const left = useAppSelector(selectLeftComparate);
  const right = useAppSelector(selectRightComparate);

  const transformSelectResult = useCallback(
    ({ data, ...rest }: typeof left | typeof right) => ({
      ...rest,
      instruments: data?.data.instruments ?? [],
    }),
    [],
  );

  return useMemo(
    () => ({
      left: transformSelectResult(left),
      right: transformSelectResult(right),
    }),
    [left, right, transformSelectResult],
  );
};

const selectComparate = (side: InstrumentComparateSide) =>
  analyticsApi.endpoints.readComparisonInstruments.select({
    side,
    payload: null as never,
  });

const selectLeftComparate = selectComparate('left');
const selectRightComparate = selectComparate('right');
